module.exports = __webpack_public_path__ + "static/chart-nguci.7be8474b.jpg";


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/chart-nguci.jpg
// module id = 1347
// module chunks = 4